// extracted by mini-css-extract-plugin
export default {"advertDetailContactGroup":"c-l_ha","advertDetailContactGroup__header":"c-l_hb","advertDetailContactGroup__value":"c-l_hc"};